import Handlebars from "handlebars";
import { getPlanTemplates } from "./readingPlan";
import { abbreviations } from "../../cpcoc/abbreviations";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const templates = {};
export function getTemplate(name) {
    return templates[name];
}
export function getTemplates() {
    return templates;
}
export function setTemplates() {
    const readingPlanTemplates = getPlanTemplates();
    const templateNames = Object.keys(readingPlanTemplates);
    for (let i = 0, l = templateNames.length; i < l; i++) {
        const templateName = templateNames[i];
        if (readingPlanTemplates[templateName]) {
            templates[templateName] = Handlebars.compile(readingPlanTemplates[templateName]);
        }
    }
    Handlebars.registerHelper("abbr", (string) => {
        const keys = Object.keys(abbreviations);
        for (let i = 0, l = keys.length; i < l; i++) {
            const abbr = keys[i];
            if (string.indexOf(abbr) > -1) {
                string = string.replace(abbr, abbreviations[abbr]);
            }
        }
        return string;
    });
}
